import React, { useState, useEffect } from 'react';
import './Homepage.scss';
import { Button, Card, Col, Container, Row } from 'react-bootstrap';
import MainLayout from '../../layouts/MainLayout';
// Ionicon {
import Sync from 'react-ionicons/lib/Sync';
import CloudUpload from 'react-ionicons/lib/CloudUpload';
import SearchFile from 'react-ionicons/lib/Search';
// }
import { FileExplorer, FilePreview } from '../../components/FileExplorer';
import * as DriveHelper from '../../helpers/Drive';
import FolderPictureURL from '../../assets/img/draw-kit/folder_2.svg';
import CommentFallbackURL from '../../assets/img/draw-kit/social_feed.svg';
import InformationFallbackURL from '../../assets/img/draw-kit/configuration.svg';
import { Drive as DriveAPI } from '../../api';
import FileBreadcrumb from '../../components/FileExplorer/FileBreadcrumb';
import { useNavigate } from 'react-router';
import { T } from '../../helpers/Language';
import AppTab from '../../components/AppTab/AppTab';
import FileInformation from '../../components/FileExplorer/FileInformation';
import FileComments from '../../components/FileExplorer/FileComment';
import { connect } from 'react-redux';
import UserAnalytic from '../../helpers/UserAnalytic';


export const getPathResources = async (folderId) => {
    const body = {
        path: {
            currentNode: folderId || 'root'
        },
        option: {
            forceNonVirtual: false,
            orderBy: {
                id: 'ASC'
            }
        }
    };
    const { data } = await DriveAPI.getPathResources(body);
    data.fileElements = DriveHelper.Transform.toFileElements(data);
    return data;
};

export const getFolderStructure = async () => {
    const resp = await DriveAPI.getFolderStructure();
    const { data } = resp;
    window.d = data;
};

export const DFLT_ICO_PROPS = {
    height: '28px',
    width: '28px',
    color: 'inherit',
    className: 'icon-cls'
};

const Homepage = ({
    userPermission
}) => {
    // state
    // const [folderStructure, setFolderStructure] = useState(null);
    const [currentFolder, setCurrentFolder] = useState({});
    const [currentBreadcrumb, setBreadcrumb] = useState({});
    const [currentFile, setCurrentFile] = useState(null);
    const [folderPath, setFolderPath] = useState([]);
    const [folderCache, setFolderCache] = useState({});
    const [isInitialize, setInitializeStatus] = useState(false);
    const [isLoading, setLoadingStatus] = useState(true);
    const parentFolderId = folderPath[folderPath.length - 1];
    const navigateManager = useNavigate();

    const keepPathDetails = (folder) => {
        const cache = { ...folderCache };
        for (const idx in folder.folder) {
            const f = folder.folder[idx];
            if (cache[f.id]) continue;
            cache[f.id] = {
                id: f.id,
                name: f.name
            };
        }
        setFolderCache(cache);
        return cache;
    };

    const generateBreadcrumb = (folderPath, folderCache) => {
        const bc = [];
        for (const idx in folderPath) {
            const folderId = folderPath[idx];
            const folder = folderCache[folderId];
            if (!folder) {
                if (folderId === 'root') {
                    bc.push({
                        id: 'root'
                    });
                    continue;
                }
                console.warn('missing folder in cache:', folderId);
            }
            bc.push(folder || null);
        }
        setBreadcrumb(bc);
    };

    // methods
    const onSelectFolder = async (folderId, forceFolderPath = null) => {
        if (folderId === currentFolder.id) return;
        setLoadingStatus(true);
        // UserAnalytic.event({
        //     category: 'module:drive',
        //     action: 'Select Folder',
        //     label: `Folder Id ${folderId}`
        // });
        try {
            setCurrentFile(null);
            const folder = await getPathResources(folderId);
            folder.id = folderId;
            const newFolderCache = keepPathDetails(folder);
            const newFolderPath = forceFolderPath ? forceFolderPath : [...folderPath, folderId];
            setFolderPath(newFolderPath);
            generateBreadcrumb(newFolderPath, newFolderCache);
            setCurrentFolder(folder);
        } catch (e) {
            console.error(e);
        }
        setLoadingStatus(false);
    };

    const refreshFolder = async (e) => {
        if (e && e.preventDefault) e.preventDefault();
        const folderId = folderPath[folderPath.length - 1];
        UserAnalytic.event({
            category: 'drive_explorer',
            action: 'Refresh Folder',
            label: `Folder Id ${folderId}`
        });
        try {
            setLoadingStatus(true);
            const folder = await getPathResources(folderId);
            setCurrentFolder(folder);
        } catch (e) { }
        setLoadingStatus(false);
    };

    const backToFolder = async (goToIndex) => {
        if (goToIndex < 0) return;
        try {
            const newFP = folderPath.slice(0, goToIndex + 1);
            await onSelectFolder(newFP[newFP.length - 1], newFP);
        } catch (e) { }
    };

    const backToParentFolder = async (e) => {
        if (e && e.preventDefault) e.preventDefault();
        const folderId = folderPath[folderPath.length - 1];
        UserAnalytic.event({
            category: 'drive_explorer',
            action: 'Back to Parent Folder',
            label: `Folder Id ${folderId}`
        });
        if (folderId === 'root') return;
        const newFolderPath = folderPath.slice(0, folderPath.length - 1);
        await onSelectFolder(newFolderPath[newFolderPath.length - 1], newFolderPath);
    };

    const goToRootFolder = async (e) => {
        if (e && e.preventDefault) e.preventDefault();
        UserAnalytic.event({
            category: 'drive_explorer',
            action: 'Go to Root Folder',
            label: `Folder Root`
        });
        await onSelectFolder('root', ['root']);
    };

    const onSelectFile = async (fileId, forceReload = false) => {
        if (!fileId) return;
        if (forceReload == false && currentFile && currentFile.id === fileId) return;
        UserAnalytic.event({
            category: 'drive_explorer',
            action: 'Select File',
            label: `Folder Id ${fileId}`
        });
        setCurrentFile({
            id: fileId,
            _isDraft: true,
            _isFetching: true
        });
        try {
            const { data } = await DriveAPI.getFileInformation(fileId);
            data._isFetching = false;
            data._isDraft = false;
            setCurrentFile({
                ...data,
                comments: data.comments.sort(DriveHelper.Sort.byCreatedAt)
            });
        } catch (e) { }
    };

    const onSendComment = async (comment) => {
        setLoadingStatus(true);
        UserAnalytic.event({
            category: 'drive_explorer',
            action: 'Send Comment',
            label: `File Id ${currentFile.id}`
        });
        try {
            const data = await DriveAPI.addCommentToFile(currentFile.id, comment);
            await onSelectFile(currentFile.id, true);
        } catch (e) {
            console.error(e);
        }
        setLoadingStatus(false);
    }

    const goToUploadCenter = () => {
        navigateManager("/documents/upload-center");
    };

    const goToSearchFilePage = () => {
        navigateManager("/documents/search");
    };

    const handleDownloadFile = (e) => {
        if (e && e.preventDefault) {
            e.preventDefault();
            e.stopPropagation();
            e.target.blur();
        }
        const url = DriveAPI.downloadFileHardLink(currentFile.id) + '&download=1';
        window.open(url, '__blank', 'noopener noreferrer');
    };

    useEffect(() => {
        async function init() {
            setInitializeStatus(true);
            await goToRootFolder();
        }
        init();
    }, [isInitialize]);
    return (
        <>
            {/* {isLoading ? <AppOverlay show={isLoading} /> : null }  */}
            {/* <AppOverlay show={true} /> */}
            <MainLayout pageTitle={T('DRIVE_FEXPLORER_TITLE_HOMEPAGE')}>
                <Container fluid className="drive-homepage">
                    <Row>
                        <Col sm={12} className="mb-2">
                            {
                                userPermission.drive_upload === true ?
                                    <Button varient="primary" className="btn shadow-lg mb-4" onClick={goToUploadCenter}>
                                        <CloudUpload {...DFLT_ICO_PROPS} />
                                        {T('DRIVE_FEXPLORER_TITLE_UPLOAD_CENTER')}
                                    </Button>
                                    : null
                            }
                            <Button variant="default" className="btn btn-default shadow-lg mb-4 ms-3" onClick={goToSearchFilePage}>
                                <SearchFile {...DFLT_ICO_PROPS} color="#000" />
                                {T('DRIVE_FEXPLORER_TITLE_SEARCH_FILE')}
                            </Button>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={12} md={12} lg={6} className="mb-4">
                            <h4>{T('DRIVE_FEXPLORER_TITLE_FILE_EXPLORER')}</h4>
                            <Card className="mb-2 rounded">
                                <Card.Body className="p-2 space-control">
                                    <Button disabled={parentFolderId === 'root'} variant="primary" onClick={(e) => backToParentFolder(e)}>{T('GEN_BACK')}</Button>
                                    <Button className={`${isLoading ? 'loading' : ''} drive-sync-button`} disabled={isLoading === true} variant="primary" onClick={(e) => refreshFolder(e)}><div className='drive-sync-group'>{isLoading ? <span className='drive-sync-text'>Sync...</span> : ''}<Sync color="inherit" className={`${isLoading ? 'spin-anim' : ''}`} /></div></Button>
                                </Card.Body>
                            </Card>
                            <Card className="mb-2 rounded">
                                <Card.Body className="p-2 space-control">
                                    <FileBreadcrumb
                                        breadcrumb={currentBreadcrumb}
                                        onSelectFolderIndex={backToFolder}
                                    />
                                </Card.Body>
                            </Card>
                            <Card className="shadow-sm">
                                <Card.Body className="p-0">
                                    <FileExplorer
                                        isLoading={isLoading}
                                        items={currentFolder.fileElements}
                                        fileSelected={currentFile}
                                        onSelectFolder={onSelectFolder}
                                        onSelectFile={onSelectFile}
                                    />
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col sm={12} md={12} lg={6}>
                            <h4>{T('DRIVE_FEXPLORER_TITLE_DETAILS')}</h4>
                            <Card className="shadow-sm">
                                <Card.Body className="p-0">
                                    <AppTab
                                        afterTabs={currentFile ? (
                                            <>
                                                <Button
                                                    onClick={handleDownloadFile}
                                                >{T('GEN_DOWNLOAD')}</Button>
                                            </>
                                        ) : null}
                                    >
                                        <AppTab.Item label={T('DRIVE_FEXPLORER_TITLE_PREVIEW')}>
                                            <div className="text-center">
                                                <FilePreview
                                                    fileElement={currentFile}
                                                    fallback={() => <img src={FolderPictureURL} height={390} />}
                                                />
                                            </div>
                                        </AppTab.Item>
                                        <AppTab.Item label={T('DRIVE_DETAILS_COMMENTS')} disabled={!currentFile}>
                                            <FileComments
                                                onSendComment={onSendComment}
                                                fileElement={currentFile}
                                                fallback={() => <div className="text-center p-5"><img src={CommentFallbackURL} height={294} /></div>}
                                            />
                                        </AppTab.Item>
                                        <AppTab.Item label={T('DRIVE_DETAILS_INFORMATION')} disabled={!currentFile}>
                                            <FileInformation
                                                fileElement={currentFile}
                                                fallback={() => <div className="text-center"><img src={InformationFallbackURL} height={390} /></div>}
                                            />
                                        </AppTab.Item>
                                    </AppTab>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </MainLayout>
        </>
    );
}

const mapStateToProps = (appState) => ({
    userProfile: appState.userProfile,
    userPermission: (appState.userProfile || {})._permissions
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Homepage);